export const environment = {
  production: true,
  flagsmithEnvironmentID: '9PfMzFB9D6TrfVqAZEbU8i'
};
